(() => {
  const d = document;
  const qs = (s, c = d) => c.querySelector(s);
  const qsa = (s, c = d) => [...c.querySelectorAll(s)];
  const routes = (window.theme && window.theme.routes) || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };
  const S = Object.assign({ add_to_cart: 'Add to cart', sold_out: 'Sold out', unavailable: 'Unavailable', save: 'Save [percent]%' }, (window.theme && window.theme.strings) || {});
  const L = (window.theme && window.theme.localization) || {};
  const ROOT = ((routes.root || '/') + '').replace(/\/?$/, '/');

  /* ---------- Cart drawer ---------- */
  const hasDrawer = () => !!qs('#CartDrawer') && !d.body.classList.contains('template-cart');
  function openCart() {
    d.body.classList.add('cart-open');
    const p = qs('#CartDrawer .drawer__panel');
    if (p) setTimeout(() => p.focus(), 50);
  }
  function closeCart() { d.body.classList.remove('cart-open'); }

  function renderSections(sections) {
    if (!sections || !sections['cart-drawer']) return;
    const tmp = d.createElement('div');
    tmp.innerHTML = sections['cart-drawer'];
    const fresh = qs('#CartDrawer', tmp);
    const cur = qs('#CartDrawer');
    if (fresh && cur) cur.replaceWith(fresh);
    const count = qs('[data-cart-count-value]', tmp);
    if (count) {
      const n = count.textContent.trim();
      qsa('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = n === '0'; });
    }
  }

  async function addToCart(form) {
    const btn = qs('[type=submit]', form);
    const err = qs('[data-form-error]', form);
    if (err) err.hidden = true;
    if (btn) btn.classList.add('is-loading');
    const fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', location.pathname);
    try {
      const res = await fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: fd
      });
      const json = await res.json();
      if (!res.ok || json.status) {
        if (err) { err.textContent = json.description || json.message || 'Sorry, this item could not be added.'; err.hidden = false; }
        return;
      }
      if (!hasDrawer()) { location.href = routes.cart_url; return; }
      renderSections(json.sections);
      openCart();
    } catch (e) {
      form.submit();
    } finally {
      if (btn) btn.classList.remove('is-loading');
    }
  }

  async function changeLine(line, quantity) {
    const panel = qs('#CartDrawer .drawer__body');
    if (panel) panel.style.opacity = '.5';
    try {
      const res = await fetch(routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: ['cart-drawer'], sections_url: location.pathname })
      });
      const json = await res.json();
      renderSections(json.sections);
    } catch (e) {
      location.href = routes.cart_url;
    }
  }

  d.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  d.addEventListener('click', (e) => {
    const t = e.target;
    const opener = t.closest('[data-cart-open]');
    if (opener && hasDrawer()) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-drawer-close]')) { e.preventDefault(); closeCart(); return; }
    const q = t.closest('[data-qty-change]');
    if (q) { e.preventDefault(); changeLine(+q.dataset.line, +q.dataset.qty); return; }
    const step = t.closest('[data-step]');
    if (step) {
      const input = qs('input', step.parentElement);
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.dataset.step, 10));
      return;
    }
    const menuClose = t.closest('[data-menu-close]');
    const menu = t.closest('details[data-menu]');
    if (menuClose || (menu && t === menu)) {
      const m = menu || qs('details[data-menu][open]');
      if (m) m.removeAttribute('open');
    }
    const upNav = t.closest('[data-upsell-prev],[data-upsell-next]');
    if (upNav) {
      const track = qs('[data-upsell-track]', upNav.closest('[data-upsell]'));
      if (track) {
        const target = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, track.scrollLeft + (upNav.hasAttribute('data-upsell-next') ? 1 : -1) * Math.max(150, track.clientWidth * 0.8)));
        track.scrollTo({ left: target, behavior: 'smooth' });
        // Fallback for browsers that skip smooth scrolling
        setTimeout(() => { if (Math.abs(track.scrollLeft - target) > 4) { track.style.scrollBehavior = 'auto'; track.scrollLeft = target; track.style.scrollBehavior = ''; } }, 450);
      }
      return;
    }
    const sticky = t.closest('[data-sticky-submit]');
    if (sticky) {
      const f = d.getElementById(sticky.dataset.stickySubmit);
      if (f) { e.preventDefault(); f.requestSubmit ? f.requestSubmit() : f.submit(); }
    }
  });

  d.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeCart();
    qsa('details[data-menu][open]').forEach((m) => m.removeAttribute('open'));
  });

  qsa('details[data-menu]').forEach((m) => m.addEventListener('toggle', () => d.body.classList.toggle('menu-open', m.open)));

  /* ---------- Header shadow ---------- */
  const header = qs('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 10);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Announcement rotator (mobile) ---------- */
  qsa('[data-rotator]').forEach((r) => {
    const items = qsa('.announce__msg', r);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      if (window.matchMedia('(min-width: 990px)').matches) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* ---------- Gallery ---------- */
  function initGallery(g) {
    const track = qs('[data-gallery-track]', g);
    const thumbs = qsa('[data-thumb]', g);
    if (!track) return;
    const slides = qsa('.gallery__slide', track);
    const go = (i) => track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    thumbs.forEach((b) => b.addEventListener('click', () => go(+b.dataset.thumb)));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach((b, n) => b.classList.toggle('is-active', n === i));
      });
    }, { passive: true });
    g.goToMedia = (id) => {
      const i = slides.findIndex((s) => s.dataset.mediaId === String(id));
      if (i > -1) go(i);
    };
  }
  qsa('[data-gallery]').forEach(initGallery);

  /* ---------- Filter + cartridge selector ---------- */
  function fmtMoney(cents, format) {
    const fixed = (cents / 100).toFixed(2).split('.');
    const comma = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const dot = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return comma;
      if (k === 'amount_with_comma_separator') return dot + ',' + fixed[1];
      if (k === 'amount_no_decimals_with_comma_separator') return dot;
      return comma + '.' + fixed[1];
    });
  }
  function initBuilder(b) {
    if (b.dataset.fbReady) return;
    b.dataset.fbReady = '1';
    const fmt = (c) => fmtMoney(c, b.dataset.moneyFormat);
    const cartId = b.dataset.cartId;
    const cartPrice = parseInt(b.dataset.cartPrice || '0', 10);
    const d2 = parseInt(b.dataset.disc2 || '0', 10);
    const d3 = parseInt(b.dataset.disc3 || '0', 10);
    const pct = (n) => (n >= 3 ? d3 : n >= 2 ? d2 : 0);
    // Shopify rounds the discount down per unit, so mirror that to match the cart
    const net = (price, n) => n * (price - Math.floor(price * pct(n) / 100));
    const priceHtml = (price, n) => {
      const full = price * n;
      const now = net(price, n);
      return now < full ? `<s>${fmt(full)}</s> ${fmt(now)}` : fmt(full);
    };
    const pick = (n) => qs(`input[name^="${n}"]:checked`, b);
    const update = () => {
      const c = pick('fb-color');
      const q = parseInt((pick('fb-qty') || { value: 1 }).value, 10);
      const k = cartId ? parseInt((pick('fb-cart') || { value: 0 }).value, 10) : 0;
      const unit = c ? parseInt(c.dataset.price, 10) : 0;
      qsa('[data-fb-qty-price]', b).forEach((el) => { el.innerHTML = priceHtml(unit, parseInt(el.dataset.fbQtyPrice, 10)); });
      qsa('[data-fb-cart-price]', b).forEach((el) => { el.innerHTML = priceHtml(cartPrice, parseInt(el.dataset.fbCartPrice, 10)); });
      const total = qs('[data-fb-total]', b);
      if (total) {
        const full = unit * q + cartPrice * k;
        const now = net(unit, q) + net(cartPrice, k);
        total.innerHTML = now < full ? `<s>${fmt(full)}</s> ${fmt(now)}` : fmt(full);
      }
      qsa('[data-atc]', b).forEach((btn) => { btn.disabled = !c; });
      const wrap = b.closest('[data-product-form]');
      const g = wrap && qs('[data-gallery]', wrap);
      if (c && c.dataset.media && g && g.goToMedia) g.goToMedia(c.dataset.media);
    };
    b.addEventListener('change', update);
    update();
    const form = qs('[data-fb-form]', b);
    if (!form) return;
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const c = pick('fb-color');
      if (!c) return;
      const q = parseInt((pick('fb-qty') || { value: 1 }).value, 10);
      const k = parseInt((pick('fb-cart') || { value: 0 }).value, 10);
      const items = [{ id: parseInt(c.value, 10), quantity: q }];
      if (k > 0 && cartId) items.push({ id: parseInt(cartId, 10), quantity: k });
      const btn = qs('[data-atc]', b);
      const err = qs('[data-form-error]', b);
      if (err) err.hidden = true;
      if (btn) btn.classList.add('is-loading');
      try {
        const res = await fetch(routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items, sections: 'cart-drawer', sections_url: location.pathname })
        });
        const json = await res.json();
        if (!res.ok || json.status) {
          if (err) { err.textContent = json.description || json.message || 'Sorry, this could not be added.'; err.hidden = false; }
          return;
        }
        if (!hasDrawer()) { location.href = routes.cart_url; return; }
        renderSections(json.sections);
        openCart();
      } catch (x) {
        if (err) { err.textContent = 'Something went wrong. Please try again.'; err.hidden = false; }
      } finally {
        if (btn) btn.classList.remove('is-loading');
      }
    });
  }
  qsa('[data-filter-builder]').forEach(initBuilder);
  /* ---------- Variant picker ---------- */
  function initProduct(wrap) {
    const json = qs('[data-variants]', wrap);
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const groups = qsa('[data-option-group]', wrap);
    if (!groups.length) return;
    wrap.addEventListener('change', (e) => {
      if (!e.target.closest('[data-option-group]')) return;
      const selected = groups.map((g) => {
        const c = qs('input:checked', g);
        const label = qs('[data-option-value]', g);
        if (c && label) label.textContent = c.value;
        return c ? c.value : null;
      });
      const v = variants.find((x) => x.options.every((o, i) => o === selected[i]));
      update(v);
    });
    function update(v) {
      const btns = qsa('[data-atc]', wrap).concat(qsa(`[data-sticky-submit="${wrap.dataset.formId}"]`));
      const labels = qsa('[data-atc-label]', wrap);
      if (!v) {
        btns.forEach((b) => (b.disabled = true));
        labels.forEach((l) => (l.textContent = S.unavailable));
        return;
      }
      qsa('[data-variant-id]', wrap).forEach((i) => (i.value = v.id));
      btns.forEach((b) => (b.disabled = !v.available));
      labels.forEach((l) => (l.textContent = v.available ? l.dataset.label || S.add_to_cart : S.sold_out));
      qsa('[data-price-now]').forEach((el) => { if (wrap.contains(el) || el.closest('[data-sticky-atc]')) el.textContent = v.price; });
      qsa('[data-price-was]').forEach((el) => { if (wrap.contains(el) || el.closest('[data-sticky-atc]')) { el.textContent = v.compare || ''; el.hidden = !v.compare; } });
      qsa('[data-price-save]').forEach((el) => { if (wrap.contains(el) || el.closest('[data-sticky-atc]')) { el.textContent = S.save.replace('[percent]', v.save); el.hidden = !v.save; } });
      const ap = qs('[data-bnpl-provider="afterpay"] strong', wrap);
      const kl = qs('[data-bnpl-provider="klarna"] strong', wrap);
      if (ap && v.afterpay) ap.textContent = v.afterpay;
      if (kl && v.klarna) kl.textContent = v.klarna;
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url.toString());
      const g = qs('[data-gallery]', wrap);
      if (g && g.goToMedia && v.media) g.goToMedia(v.media);
    }
  }
  qsa('[data-product-form]').forEach(initProduct);

  /* ---------- Sticky add to cart / CTA ---------- */
  qsa('[data-sticky-atc]').forEach((bar) => {
    const target = d.getElementById(bar.dataset.watch);
    if (!target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([entry]) => {
      const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
      bar.setAttribute('aria-hidden', String(!past));
    }).observe(target);
  });

  /* ---------- Recommendations ---------- */
  async function loadRecs(el) {
    try {
      const html = await fetch(el.dataset.url).then((r) => r.text());
      const tmp = d.createElement('div');
      tmp.innerHTML = html;
      const inner = qs('[data-recs]', tmp);
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
      else if (!L.designMode) el.closest('.shopify-section')?.remove();
    } catch (e) { /* ignore */ }
  }
  qsa('[data-recs]').forEach(loadRecs);

  /* ---------- Cart refresh for apps (bundles, subscriptions, upsells) ---------- */
  async function refreshCart(open) {
    try {
      const res = await fetch(`${ROOT}?sections=cart-drawer`);
      renderSections(await res.json());
      if (open && hasDrawer()) openCart();
    } catch (e) { /* ignore */ }
  }
  window.theme = Object.assign(window.theme || {}, { openCart, closeCart, refreshCart });
  ['cart:refresh', 'cart:updated', 'cart:change', 'appstle:cart:updated'].forEach((ev) => d.addEventListener(ev, () => refreshCart(true)));
  // When an app adds to cart with its own request, refresh and open the drawer.
  const nativeFetch = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const res = await nativeFetch(...args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      const opts = args[1] || {};
      const ours = opts.headers && (opts.headers['X-Requested-With'] === 'XMLHttpRequest' || (opts.body && String(opts.body).includes('cart-drawer')));
      if (!ours && /\/cart\/(add|change|update)(\.js)?/.test(url) && res.ok) setTimeout(() => refreshCart(/\/cart\/add/.test(url)), 50);
    } catch (e) { /* ignore */ }
    return res;
  };

  /* ---------- Visitor country (geo) ---------- */
  function detectCountry() {
    try {
      const cached = sessionStorage.getItem('rx_geo');
      if (cached) return Promise.resolve(cached);
    } catch (e) { /* ignore */ }
    return nativeFetch(`${ROOT}browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true`)
      .then((r) => r.json())
      .then((j) => {
        const c = (j.detected_values && j.detected_values.country && j.detected_values.country.handle) || L.country || '';
        try { sessionStorage.setItem('rx_geo', c); } catch (e) { /* ignore */ }
        return c;
      })
      .catch(() => L.country || '');
  }

  /* ---------- Pay later messaging ---------- */
  const bnpls = qsa('[data-bnpl]');
  if (bnpls.length) {
    // Move the PayPal Pay Later message (injected by the PayPal app) under the price.
    const movePaypal = () => {
      const msg = d.getElementById('paypal-upstream-messaging-product') || qs('.pform [data-pp-message]');
      const slot = qs('[data-bnpl-paypal]');
      if (msg && slot && !slot.contains(msg)) slot.appendChild(msg);
      return !!(msg && slot && slot.contains(msg));
    };
    if (!movePaypal()) {
      const mo = new MutationObserver(() => { if (movePaypal()) mo.disconnect(); });
      mo.observe(d.body, { childList: true, subtree: true });
      setTimeout(() => mo.disconnect(), 15000);
    }
    detectCountry().then((country) => {
      bnpls.forEach((b) => {
        const ap = (b.dataset.afterpayCountries || '').split(',');
        const kl = (b.dataset.klarnaCountries || '').split(',');
        const apEl = qs('[data-bnpl-provider="afterpay"]', b);
        const klEl = qs('[data-bnpl-provider="klarna"]', b);
        if (apEl) apEl.hidden = !ap.includes(country);
        if (klEl) klEl.hidden = !kl.includes(country);
      });
    });
  }

  /* ---------- Auto country / language on first visit ---------- */
  const LANG_BY_COUNTRY = { NL: 'nl', BE: 'nl', DE: 'de', AT: 'de', CH: 'de', PL: 'pl', FR: 'fr', ES: 'es', IT: 'it', PT: 'pt-PT', SE: 'sv', DK: 'da', FI: 'fi', NO: 'nb', GB: 'en', IE: 'en', US: 'en', CA: 'en', AU: 'en', NZ: 'en' };
  (function autoLocalize() {
    if (!L.auto || L.designMode) return;
    try {
      if (localStorage.getItem('rx_loc_manual') || localStorage.getItem('rx_loc_done')) return;
      localStorage.setItem('rx_loc_done', '1');
    } catch (e) { return; }
    detectCountry().then((country) => {
      if (!country) return;
      const form = qs('[data-auto-localization-form]');
      if (!form) return;
      const wantLang = LANG_BY_COUNTRY[country];
      const langOk = wantLang && (L.languages || []).includes(wantLang);
      const countryOk = (L.countries || []).includes(country);
      const changeCountry = countryOk && country !== L.country;
      const changeLang = langOk && wantLang !== L.language;
      if (!changeCountry && !changeLang) return;
      if (changeCountry) qs('[name="country_code"]', form).value = country;
      if (changeLang) qs('[name="language_code"]', form).value = wantLang;
      form.submit();
    });
  })();

  /* ---------- Reveal on scroll ---------- */
  // Disabled in the theme editor so sections never render blank while editing.
  let io = null;
  if (!L.designMode && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    d.documentElement.classList.add('reveal-ready');
    io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0.05 });
  }
  function initReveal(root) {
    const els = qsa('.reveal:not(.is-in)', root);
    if (root.matches && root.matches('.reveal:not(.is-in)')) els.push(root);
    if (!els.length) return;
    if (!io) { els.forEach((el) => el.classList.add('is-in')); return; }
    els.forEach((el) => io.observe(el));
    // Safety net: never leave content hidden
    setTimeout(() => els.forEach((el) => el.classList.add('is-in')), 3500);
  }
  initReveal(d);
  // Content inserted later (recommendations, app widgets) gets revealed too.
  new MutationObserver((muts) => {
    muts.forEach((m) => m.addedNodes.forEach((n) => { if (n.nodeType === 1) initReveal(n); }));
  }).observe(d.body, { childList: true, subtree: true });

  /* ---------- Description preview (Read more) ---------- */
  function initClamp(root) {
    qsa('[data-clamp]', root).forEach((box) => {
      const btn = box.parentElement.querySelector('[data-clamp-toggle]');
      if (!btn || box.dataset.clampReady) return;
      box.dataset.clampReady = '1';
      const check = () => {
        const needs = box.scrollHeight > box.clientHeight + 8;
        if (!needs && !box.classList.contains('is-open')) { box.classList.add('no-clamp'); btn.hidden = true; } else { btn.hidden = false; }
      };
      check();
      // Re-check once images/fonts inside the description load
      window.addEventListener('load', check, { once: true });
      btn.addEventListener('click', () => {
        const open = box.classList.toggle('is-open');
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
        btn.setAttribute('aria-expanded', String(open));
        if (!open) box.closest('details').scrollIntoView({ block: 'nearest' });
      });
    });
  }
  initClamp(d);
  /* ---------- Theme editor: re-init a section after it is edited ---------- */
  d.addEventListener('shopify:section:load', (e) => {
    const s = e.target;
    qsa('.reveal', s).forEach((el) => el.classList.add('is-in'));
    qsa('[data-gallery]', s).forEach(initGallery);
    qsa('[data-product-form]', s).forEach(initProduct);
    qsa('[data-recs]', s).forEach(loadRecs);
    initClamp(s);
    qsa('[data-filter-builder]', s).forEach(initBuilder);
  });
})();
